import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { GenericModal } from "@Shared/components/modals";
import LenderInformation from "./lender-information-block.vue";
import ResponseDetailsBlock from "./response-details-block.vue";
import DeclineReasonBlock from "./decline-reason-block";
import { mapActions } from "vuex";
import { SUBMIT_MANUAL_RESPONSE, LOAD_MANUAL_RESPONSE } from "../../../../store/lender-submit-actions";
import InlineLoader from "@Shared/components/general/inline-loader.vue";
import { isEmpty } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ManualResponseModal",
  components: {
    GenericModal,
    LenderInformation,
    ResponseDetailsBlock,
    DeclineReasonBlock,
    InlineLoader
  },
  props: {
    applicationData: {
      type: Object,
      required: true
    },
    isDecisionAccepted: {
      type: Boolean,
      default: true
    },
    clientUsername: {
      type: String,
      required: true
    },
    applicationId: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      loanDecision: {},
      isLenderInformationValid: false,
      isResponseDetailsValid: false,
      isDeclineReasonValid: false,
      submittingManualResponse: false
    };
  },
  computed: {
    isResponseValid() {
      const {
        isLenderInformationValid,
        isResponseDetailsValid,
        isDeclineReasonValid,
        isDecisionAccepted
      } = this;
      const declinedValid = !isDecisionAccepted && isDeclineReasonValid;
      const approvedValid = isDecisionAccepted && isResponseDetailsValid;
      return isLenderInformationValid && (declinedValid || approvedValid);
    },
    currentSubmittedApplicationId() {
      return this.applicationData.submittedApplicationId;
    },
    lenderInformationProps() {
      return isEmpty(this.applicationData) ? {} : {
        lenderName: this.applicationData.lenderName,
        responseDecision: this.isDecisionAccepted ? "accepted" : "declined",
        submittedApplicationId: this.currentSubmittedApplicationId
      };
    },
    validButtonIcon() {
      return this.isResponseValid ? "fa-check-circle text-success" : "fa-times-circle text-danger";
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions("ApplicationStore", [SUBMIT_MANUAL_RESPONSE, LOAD_MANUAL_RESPONSE])), {}, {
    initLoanDecision() {
      this.LOAD_MANUAL_RESPONSE({
        applicationData: this.applicationData,
        isDecisionAccepted: this.isDecisionAccepted
      });
    },
    lenderInformationValidationChange(valid) {
      this.isLenderInformationValid = valid;
    },
    responseDetailsValidationChange(valid) {
      this.isResponseDetailsValid = valid;
    },
    declineReasonValidationChange(valid) {
      this.isDeclineReasonValid = valid;
    },
    clearData() {
      this.isLenderInformationValid = false;
      this.isResponseDetailsValid = false;
      this.isDeclineReasonValid = false;
      this.submittingManualResponse = false;
    },
    async submitManualResponse() {
      this.submittingManualResponse = true;
      try {
        await this.SUBMIT_MANUAL_RESPONSE({
          clientUsername: this.clientUsername,
          applicationId: this.applicationId,
          submissionId: this.applicationData.submissionId,
          submittedApplicationId: this.currentSubmittedApplicationId
        });
        this.hide();
      } catch (e) {
        this.submittingManualResponse = false;
      }
    },
    show() {
      this.$refs.manualResponseModal.show();
    },
    hide() {
      this.$refs.manualResponseModal.hide();
    }
  })
});